/**
 * File search.js.
 *
 * Search stuff for mobile.
 */

(function ($) {
    var viewportWidth = $(window).width();

    if (viewportWidth < 783) {
        trigger_mobile_search();
    }

    $(window).on('resize', function () {

        var viewportWidth = $(window).width();

        if (viewportWidth < 783) {
            trigger_mobile_search();

        } else {
            trigger_desktop_search();
        }
    });

    function trigger_mobile_search() {
        var search_form = $('.header__actions .search-form');
        search_form.remove();
        $('.header__top').after(search_form);
        search_form.wrap('<div class="search__mobile"></div>');

        $('.search-toggle').on('click', function (e) {
            e.preventDefault();
            var is_expanded = $(this).attr('aria-expanded');
            $('.search__mobile').toggle();
            if (is_expanded == 'true') {
                $(this).attr('aria-expanded', false);
            } else {
                $(this).attr('aria-expanded', true);
            }
        });
    }

    function trigger_desktop_search() {
        var search_form = $('.search__mobile .search-form');
        search_form.remove();
        search_form.unwrap();
        $('.header__actions').prepend(search_form);
    }

})(window.jQuery);
